import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sidebar-logo-header-loader"
export default class extends Controller { 
  static targets = ["logoLoader", "logoLoadingSection"];

  startLoading = () => {
    $(this.logoLoadingSectionTarget).animate({ opacity: 0.1 }, "fast");
    $(this.logoLoaderTarget).show();
  }
}
